module.exports = __webpack_public_path__ + "img/DE00484.776bbcf1.png";